import { createApp } from 'vue';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

const mapItems = document.querySelectorAll('.webien-kiruna-route');

mapItems.forEach((mapItem) => {

    let $app = createApp({
        name: "mapItem-" + mapItem.dataset.unique,
        data() {
            return {
                settings: window['widgetSettings_' + mapItem.dataset.unique],
                routes: [],
                mapboxToken: 'pk.eyJ1IjoibWlrYWVsYmV2ZW50b3JwIiwiYSI6ImNtaGJ6a3JlaDF1YmIyanBjbWhjaXNucmgifQ.UKTfy-S7brFUFUMX1JQTtA',
                currentStop: null,
                groupedStops: [],
                stopTimer: null,
                lineAnimationTimer: null,
                stopTimerDuration: 10000,
                flyTime: 4000,

            }
        },
        mixins: [


        ],
        computed: {
            route() {
                if(this.settings.routes && this.settings.routes.length){
                    return this.settings.routes[0];
                }
                return false;
            },
            stops() {
                if(this.route && this.route.stops){
                    return this.route.stops;
                }
                return [];
            },
            startCoordinates() {
                if(this.stops.length && this.stops[0].coordinates.lng && this.stops[0].coordinates.lng){
                    return [this.stops[0].coordinates.lng, this.stops[0].coordinates.lat];
                }
                return [0, 0];
            },
            activeStop() {
                return this.stops[this.currentStop];
            },
            currentGroup() {
                for(let i = 0; i < this.groupedStops.length; i++){
                    if(this.groupedStops[i].find(stop => stop.time === this.activeStop.time)){
                        return this.groupedStops[i];
                    }
                }
                return [];
            }

        },
        watch: {

        },
        methods: {
            init() {

                this.groupStops();
                this.initMap();

                this.stopTimerDuration = (this.settings.stopDuration ? parseInt(this.settings.stopDuration) : 10) * 1000;

            },
            groupStops(){
                let groups = [];
                let index = 0;

                this.stops.forEach((stop, i) => {
                    if(stop.new_group && i !== 0){
                        index++;
                    }

                    // Always assign new group attribute to first stop
                    if(this.stops.length && !this.stops[0].new_group){
                        this.stops[0].new_group = true;
                    }

                    if(!groups[index]){
                        groups[index] = [];
                    }
                    groups[index].push(stop);
                });



                this.groupedStops = groups;

            },
            initMap() {
                let app = this;
                mapboxgl.accessToken = this.mapboxToken;

                window['map_' + mapItem.dataset.unique] = new mapboxgl.Map({
                    container: 'map_container_' + mapItem.dataset.unique,
                    // startCoordinates is used as center for the map, but it will be overridden by fitBounds if bounds are set
                    center: this.startCoordinates,
                    zoom: 10,
                    config: {
                        basemap: {
                            showPlaceLabels: false,
                            showRoadLabels: false,
                            showTransitLabels: false,
                            showAdminBoundaries: true,
                            showLandmarkIcons: true,
                            theme: app.settings.mapTheme ?? 'default',
                        },
                    },
                });


                // On load zoom bound to level 8
                window['map_' + mapItem.dataset.unique].on('load', () => {

                    // Remove scroll zoom
                    window['map_' + mapItem.dataset.unique].scrollZoom.disable();

                    // Disable all interactivity if only one destination
                    window['map_' + mapItem.dataset.unique].boxZoom.disable();
                    window['map_' + mapItem.dataset.unique].dragPan.disable();
                    window['map_' + mapItem.dataset.unique].dragRotate.disable();
                    window['map_' + mapItem.dataset.unique].keyboard.disable();
                    window['map_' + mapItem.dataset.unique].doubleClickZoom.disable();
                    window['map_' + mapItem.dataset.unique].touchZoomRotate.disable();
                });



                // When style is ready, add markers and route
                window['map_' + mapItem.dataset.unique].on('style.load', () => {
                    app.goToStop(0);
                });


                /*
                // Load 3d stuff
                if (!document.getElementById('threebox-js')) {
                    let threeboxScript = document.createElement('script')
                    threeboxScript.setAttribute('src', 'https://d39637iv3eybjn.cloudfront.net/threebox.min.js')
                    threeboxScript.setAttribute('id', 'threebox-js')
                    document.body.appendChild(threeboxScript)

                    // now wait for it to load...
                    threeboxScript.onload = () => {

                        // Delay this so other maps on page wont slow down
                        setTimeout(() => {
                            app.startThreebox();
                        }, 3000)

                    }
                }

                 */

            },
            resetMarkers() {
                // Remove all markers
                let markers = document.querySelectorAll('#mapItem-' + mapItem.dataset.unique + ' .marker-stop');
                markers.forEach((marker) => {
                    marker.remove();
                });

            },
            createMarkers() {
                this.resetMarkers();

                this.currentGroup.forEach((stop, i) => {
                    // Make sure we have lat/lng first
                    if(!stop.coordinates.lat || !stop.coordinates.lng){
                        return;
                    }

                    // create the popup
                    let markerPopup = '<div class="popup">' +
                        '<div class="popup-img"><img src="' + stop.image + '"></div>' +
                        '<div class="popup-close"></div>' +
                        '<div class="popup-descr"><span class="title">' + stop.title + '</span>' + stop.description + '</div>' +
                        '</div>';


                    // Create a DOM element for the marker
                    let markerHtml = '<div class="marker-stop marker-stop-' + i +  '">' +
                        '<div class="inner">' +
                        '<div class="time">' + stop.time + '</div>' +
                        '<div class="title">' + stop.title + '</div>' +
                        '<div class="dot"></div>' +
                        '<div class="line"></div>' +
                        '</div>' + markerPopup
                    '</div>';
                    const el = document.createElement('div');
                    el.innerHTML = markerHtml;

                    // Add marker to map
                    const marker = new mapboxgl.Marker(el)
                        .setLngLat([stop.coordinates.lng, stop.coordinates.lat])
                        .addTo(window['map_' + mapItem.dataset.unique]);
                })

            },
            drawRouteOnMap(stop) {

                // If we are in the same group as before, just return, else clear and draw new group


                if(stop.new_group){
                    this.clearRoutes();
                } else {
                    return;
                }

                //console.log('Draw route on map for stop', stop);

                this.currentGroup.forEach((stop, i) => {

                    if(!stop.route || !stop.route.coordinates){
                        return;
                    }
                    let route = stop.route;

                    // If route has been disabled in admin skip
                    if(stop.show_next_route === false){
                        return;
                    }


                    // Print the rout to the map
                    window['map_' + mapItem.dataset.unique].addSource('route_' + i, {
                        'type': 'geojson',
                        'data': {
                            'type': 'Feature',
                            'properties': {},
                            'geometry': route
                        }
                    });

                    window['map_' + mapItem.dataset.unique].addLayer({
                        'id': 'route_shadow_' + i,
                        'type': 'line',
                        'slot': 'middle',
                        'source': 'route_' + i,
                        'layout': {
                            'line-join': 'round',
                            'line-cap': 'round'
                        },
                        'paint': {
                            'line-color': 'rgba(112, 71, 156, 0.2)',
                            'line-width': 30,
                            'line-emissive-strength': 1
                        }
                    });
                    window['map_' + mapItem.dataset.unique].addLayer({
                        'id': 'route_shadow3_' + i,
                        'type': 'line',
                        'slot': 'middle',
                        'source': 'route_' + i,
                        'layout': {
                            'line-join': 'round',
                            'line-cap': 'round'
                        },
                        'paint': {
                            'line-color': 'rgba(112, 71, 156, 0.3)',
                            'line-width': 20,
                            'line-emissive-strength': 1
                        }
                    });

                    window['map_' + mapItem.dataset.unique].addLayer({
                        'id': 'route_shadow2_' + i,
                        'type': 'line',
                        'slot': 'middle',
                        'source':'route_' + i,
                        'layout': {
                            'line-join': 'round',
                            'line-cap': 'round'
                        },
                        'paint': {
                            'line-color': '#fff',
                            'line-width': 8,
                            'line-emissive-strength': 1
                        }
                    });

                    window['map_' + mapItem.dataset.unique].addLayer({
                        'id': 'route_' + i,
                        'type': 'line',
                        'slot': 'middle',
                        'source': 'route_' + i,
                        'layout': {
                            'line-join': 'round',
                            'line-cap': 'round'
                        },
                        'paint': {
                            'line-color': '#70479c',
                            'line-width': 6,
                            'line-emissive-strength': 1
                        }
                    });
                });



            },
            goToStop(index) {
                let app = this;
                clearInterval(this.stopTimer);
                app.currentStop = index;

                // Set lightning based on time
                let time = app.stops[index].time.split(':');
                let hour = parseInt(time[0]);

                // Map har 4 light settings, dawn, day, dusk, night.
                let lightSetting = 'day';
                if(hour > 5 && hour <= 9){
                    lightSetting = 'dawn';
                } else if(hour > 9 && hour <= 17){
                    lightSetting = 'day';
                } else if(hour > 17 && hour <= 23){
                    lightSetting = 'dusk';
                } else {
                    lightSetting = 'night';
                }

                if(app.settings.useLightning) {
                    window['map_' + mapItem.dataset.unique].setConfigProperty('basemap', 'lightPreset', lightSetting);

                    // Also add the lightning mode as a class on body so we can adjust other styles based on time of day
                    document.body.classList.remove('light-dawn', 'light-day', 'light-dusk', 'light-night');
                    document.body.classList.add('light-' + lightSetting);


                }


                // Update markers if showing a new group
                // Look inside the current group if the stop is present or not
                let newGroup = false;
                this.currentGroup.forEach((stop) => {
                    if(stop.time === app.stops[index].time){
                        newGroup = true;
                    }
                 });

                if(app.stops[index].new_group || newGroup){
                    // Markers in current group ony
                    this.createMarkers();
                    this.drawRouteOnMap(app.stops[index]);
                }


                // Center map on marker, set the bearing towards the next stop if we have more than one stop. Set the pitch as high as possible, but enough to not clip the marker and the next marker.
                // Also, make sure all the coordinates from the next route is put in a bounds so we can fit the route in the view.
                let bearing = 0;
                let pitch = 60;
                let padding = 50;
                let bounds = new mapboxgl.LngLatBounds();

                if(app.stops[index + 1]){
                    let start = app.stops[index].coordinates;
                    let end = app.stops[index + 1].coordinates;
                    bearing = Math.atan2(end.lng - start.lng, end.lat - start.lat) * (180 / Math.PI);

                    // We just want to nudge the bearing, not go full out, so based on last bearing, update it with +-30 degrees depending on direction of turn
                    if(app.stops[index + 2]){
                        let next = app.stops[index + 2].coordinates;
                        let nextBearing = Math.atan2(next.lng - end.lng, next.lat - end.lat) * (180 / Math.PI);
                        let bearingDiff = nextBearing - bearing;

                        if(bearingDiff > 0){
                            // Turn right, nudge bearing to the right
                            bearing += Math.min(bearingDiff, 30);
                        } else {
                            // Turn left, nudge bearing to the left
                            bearing += Math.max(bearingDiff, -30);
                        }
                    }


                    // Skip on mobile
                    if(window.innerWidth > 768){
                        // If we are on the first stop of a group, add coordinates of the next item to the bounds
                        if(app.settings.startOverview && app.currentGroup[0].time === app.stops[index].time && app.stops[index + 1]){
                            bounds.extend([app.stops[index + 1].coordinates.lng, app.stops[index + 1].coordinates.lat]);
                            padding = 150;
                        }
                    }
                }


                // Also add the current stop to the bounds
                bounds.extend([app.stops[index].coordinates.lng, app.stops[index].coordinates.lat]);

                window['map_' + mapItem.dataset.unique].fitBounds(bounds, {
                    padding: padding,
                    bearing: bearing,
                    duration: app.flyTime,
                    pitch: pitch,
                    maxZoom: 18
                });

                app.startStopTimer();

            },
            startStopTimer() {
                let app = this;
                if(this.stopTimer){
                    clearInterval(this.stopTimer);
                }

                let timer = 0;

                this.stopTimer = setInterval(() => {
                    timer += 10;


                    if(timer === app.flyTime) {
                        // Start animating line after fly time
                        app.$refs['stop-' + app.currentStop][0].classList.add('animate-line');
                    }



                    if(timer >= app.stopTimerDuration) {
                        app.currentStop++;
                        // Stop at last
                        if(app.currentStop >= app.stops.length){
                            app.currentStop = app.stops.length - 1;
                        }


                        app.goToStop(app.currentStop);

                        app.startStopTimer();

                    }

                }, 10);
            },

            clearRoutes() {

                let i = 0;
                while(i < 20){
                    if(window['map_' + mapItem.dataset.unique].getLayer('route_' + i)){
                        window['map_' + mapItem.dataset.unique].removeLayer('route_' + i);
                    }
                    if(window['map_' + mapItem.dataset.unique].getLayer('route_shadow_' + i)){
                        window['map_' + mapItem.dataset.unique].removeLayer('route_shadow_' + i);
                    }
                    if(window['map_' + mapItem.dataset.unique].getLayer('route_shadow2_' + i)){
                        window['map_' + mapItem.dataset.unique].removeLayer('route_shadow2_' + i);
                    }
                    if(window['map_' + mapItem.dataset.unique].getLayer('route_shadow3_' + i)){
                        window['map_' + mapItem.dataset.unique].removeLayer('route_shadow3_' + i);
                    }
                    if(window['map_' + mapItem.dataset.unique].getSource('route_' + i)){
                        window['map_' + mapItem.dataset.unique].removeSource('route_' + i);
                    }
                    i++;
                }
            },

            startThreebox() {

                let app = this;

                window['map_' + mapItem.dataset.unique].setMaxZoom(20);

                const origin = app.startCoordinates;

                const tb1 = (window.tb = new Threebox(window['map_' + mapItem.dataset.unique], window['map_' + mapItem.dataset.unique].getCanvas().getContext("webgl"), {
                    defaultLights: true,
                    enableSelectingObjects: false //change this to false to disable 3D objects selection
                    // change this to false to disable default tooltips on fill-extrusion and 3D models
                }));


                // create two three.js lights to illuminate the model
                const directionalLight = new THREE.DirectionalLight(0xffffff);
                directionalLight.position.set(0, -70, 100).normalize();
                tb1.scene.add(directionalLight);


                const directionalLight2 = new THREE.DirectionalLight(0xffffff);
                directionalLight2.position.set(0, 70, 100).normalize();
                tb1.scene.add(directionalLight2);


                // https://sketchfab.com/nenjo

                const options1 = {
                    id: "circuit",
                    type: "glb",
                    obj:
                        "https://d39637iv3eybjn.cloudfront.net/city_bus_3d_model_free_download.glb",
                    scale: 5,
                    units: "meters",
                    anchor: "center",
                    rotation: {x: 90, y: 62, z: 0}
                };

                tb1.loadObj(options1, (model) => {
                    const obj1 = model.setCoords(origin);
                    tb1.add(obj1);
                });

                window['map_' + mapItem.dataset.unique].addLayer({
                    id: "custom_layer_1",
                    type: "custom",
                    renderingMode: '3d',
                    render: function (gl, matrix) {
                        tb1.update();
                    }
                });


            },
            animateBusRoute() {
                //Animate the threebox object along the current route. Always update the bearing so it faces the direction of movement. If we have a next stop, also add the bearing towards the next stop so it will turn in time towards the next stop.

            }


        },
        mounted: function () {
            let app = this;
            this.init();
        },
        created() {

        },
        components: {
        },
    });

    // Mount app to DOM
    if(document.getElementById('mapItem-' + mapItem.dataset.unique)){
        $app.mount('#mapItem-' + mapItem.dataset.unique);
    }

});